
import React, { useState, useEffect } from "react";
import PopupForm from "../../../Components/PopupForm";
import { useTranslation } from "react-i18next"
import mainUnitObject, {
  checkErrors,
  objectMerge,
  resetErrors,
  resetObject,
} from "../../../Errors/MainUnits/MainUnit";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import mainUnitApi from "../../../Network/MainUnit";
import RenderFooter from "./RenderFooter";
import RenderContent from "./RenderContent";
import helpers from "../../../assets/js/helper";

const cookies = new Cookies();



const controller = new AbortController();
export default function UnitPlateFormContainer(props) {
  const [t] = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const [unit, setUnit] = useState(mainUnitObject);

  const navigate = useNavigate();

  const deleteImage = async (id) => {
    try {
      const jwt = cookies.get("token");

      var headers = {
        jwt: jwt,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };

      const result = await mainUnitApi.deleteImage({

        data: { id: id },
        headers: {
          ...headers,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    } catch (error) {

      toast.error(error.message);
    }

  }
  const submit = async () => {

    try {
      const jwt = cookies.get("token");

      var headers = {
        jwt: jwt,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };


      let checkErrorObject = {
        ...unit
      }
      let hasError = false
      // let readyToSendObject = {}
      let data = new FormData()
      let ownerName = unit?.owner_name?.value?.trim()
      data.append('owner_name', ownerName?.replace(/\\|\/|\'/g, ""));

      let plate_number = unit?.plate_number?.value?.trim()
      if (unit?.plate_number?.value && unit?.plate_number?.value?.trim()?.length > 0) {
        // readyToSendObject["plate_number"] = plate_number?.replace(/\\|\/|\'/g, "");
        data.append('plate_number', plate_number?.replace(/\\|\/|\'/g, ""));
      }
      else {
        hasError = true
        checkErrorObject['plate_number']['error'] = true
        checkErrorObject['plate_number']['message'] = [t('GLOBAL.mandatory_field')]
      }


      if (unit?.plate_letter_id?.value?.id !== null && unit?.plate_letter_id?.value?.id?.length > 0) {
        // readyToSendObject["plate_letter"] = unit?.plate_letter_id?.value?.id != "بدون" ? unit?.plate_letter_id?.value?.id : "";
        data.append('plate_letter', unit?.plate_letter_id?.value?.id != "بدون" ? unit?.plate_letter_id?.value?.id : "");
      }
      else {
        hasError = true
        checkErrorObject['plate_letter_id']['error'] = true
        checkErrorObject['plate_letter_id']['message'] = [t('GLOBAL.mandatory_field')]
      }

      if (unit?.plate_province_id?.value?.id !== null && unit?.plate_province_id?.value?.id?.length > 0) {
        // readyToSendObject["plate_province"] = unit?.plate_province_id?.value?.id;
        data.append('plate_province', unit?.plate_province_id?.value?.id);
      }
      else {
        hasError = true
        checkErrorObject['plate_province_id']['error'] = true
        checkErrorObject['plate_province_id']['message'] = [t('GLOBAL.mandatory_field')]
      }
      if (unit?.plate_type_id?.value?.id !== null && unit?.plate_type_id?.value?.id?.length > 0) {
        // readyToSendObject["plate_type"] = unit?.plate_type_id?.value?.id;
        data.append('plate_type', unit?.plate_type_id?.value?.id);
      }
      else {
        hasError = true
        checkErrorObject['plate_type_id']['error'] = true
        checkErrorObject['plate_type_id']['message'] = [t('GLOBAL.mandatory_field')]
      }
      
      // readyToSendObject["also_update_wialon"] = unit?.also_update_wialon?.value?1:0;
      data.append('also_update_wialon', unit?.also_update_wialon?.value ? 1 : 0);

      if (hasError) {
        setUnit({
          ...checkErrorObject
        })
        return
      }

      setLoading(true);
      let result = null

      // readyToSendObject["updateOrEdit"] = props?.updateOrEdit

      data.append('updateOrEdit', props?.updateOrEdit);

      // readyToSendObject["id"] = props?.mainUnit?.id;
      data.append('id', props?.mainUnit?.id);

      Array.isArray(unit?.images?.value) && unit?.images?.value.forEach((image, index) => {

        if (image?.file) {
          data.append('images[' + index + '][image]', image?.file);
        }

      });

      result = await mainUnitApi.editPlateMainUnitTemp({
        // data: readyToSendObject,
        data: data,

        id: props?.mainUnit?.id,
        headers: {
          ...headers,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });


      setLoading(false);


      if (result?.status && result?.data?.status) {

        setLoading(false);

        toast.success(t("NETWORK_MESSAGES.infoAddedSuccessfully"));
        refreshFromWialon({ main_unit_id: props?.mainUnit?.id })
        clearForm();
        props.loadData();
        props.setOpenForm(false);
      }
      else if (result?.data?.data?.message?.text == "unauthorized to complete") {
        navigate("/redirect");
      }

      else {

        toast.success(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
      }

      setLoading(false);
    } catch (error) {

      setLoading(false);
      props.setOpenForm(false);
      toast.error(error.message);
    }

  };

  const refreshFromWialon = async (params) => {
    const jwt = cookies.get("token");

    var headers = {
      jwt: jwt,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    };
    let object = {
      ...params,
    };


    const result = await mainUnitApi.refreshDataFromWialon({
      params: object,
      signal: controller?.signal,
      headers: headers

    });


  };

  const clearForm = () => {


    setUnit({
      plate_type_id: {
        value: "",
        error: false,
        message: "",
        required: false
      },
      plate_province_id: {
        value: "",
        error: false,
        message: "",
        required: false
      },
      plate_letter_id: {
        value: "",
        error: false,
        message: "",
        required: false
      }, plate_number: {
        value: "",
        error: false,
        message: "",
        required: false
      },
      arabic_or_english: {
        value: {
          id: t('GLOBAL.arabic'),
          name: t('GLOBAL.arabic')
        },
        error: false,
        message: "",
        required: false
      },
    })
  };

  useEffect(() => {
    if (!props?.mainUnit) {
      clearForm();

    } else {

      let plateNumber = props?.mainUnit?.plate_number
      let plateLetter = props?.mainUnit?.plate_letter
      let plateProvince = props?.mainUnit?.plate_province
      let fullPlateNumber = plateProvince + " " + (plateLetter ? plateLetter : "") + " " + plateNumber
      let newFullPlateNumber = fullPlateNumber

      if (props?.updateOrEdit == "update") {
        if (props?.mainUnit?.plate_letter && !helpers.isAllEnglishLetters(props?.mainUnit?.plate_letter)) {
          // this plate with arabic letter
          plateLetter = helpers?.convertArabicToEnglish(plateLetter)
          plateProvince = helpers?.mapProvincesToCode(plateProvince)?.id
        }
        else if (!props?.mainUnit?.plate_letter) {
          // this plate with out letters
          let updatedPlateNumberResult = helpers?.updatePlateNumber(plateNumber)

          plateNumber = updatedPlateNumberResult?.number
          plateLetter = updatedPlateNumberResult?.letter
          plateProvince = helpers?.mapProvincesToCode(plateProvince)?.id
        }

        newFullPlateNumber = plateProvince + " " + plateLetter + " " + plateNumber
      }

      setUnit({
        ...props?.mainUnit,
        id: props?.mainUnit?.id,
        fullPlateNumber: fullPlateNumber,
        newFullPlateNumber: newFullPlateNumber,
        also_update_wialon: {
          value: true,
          error: false,
          message: "",
          required: false
        },
        plate_number: {
          value: plateNumber,
          error: false,
          message: "",
          required: false
        },
        arabic_or_english: {
          value: {
            id: helpers.isAllEnglishLetters(plateLetter) ? t('GLOBAL.english') : t('GLOBAL.arabic'),
            name: helpers.isAllEnglishLetters(plateLetter) ? t('GLOBAL.english') : t('GLOBAL.arabic')
          },
          error: false,
          message: "",
          required: false
        },
        plate_type_id: {
          value: {
            id: props?.mainUnit?.plate_type,
            name: props?.mainUnit?.plate_type
          },
          error: false,
          message: "",
          required: false
        },
        plate_province_id: {
          value: {
            id: plateProvince,
            name: plateProvince,
          },
          error: false,
          message: "",
          required: false
        },
        plate_letter_id: {
          value: {
            id: plateLetter ? plateLetter : "بدون",
            name: plateLetter ? plateLetter : "بدون"
          },
          error: false,
          message: "",
          required: false
        },
        owner_name: {
          value: props?.mainUnit?.owner_name,
          error: false,
          message: "",
          required: false
        },
        images: {
          value: Array.isArray(props?.mainUnit?.images) ? props?.mainUnit?.images : [],
          error: false,
          message: "",
          required: false
        }
      })


    }
  }, [props?.openForm, props?.mainUnit]);



  return (
    <PopupForm
      open={props.openForm}
      setOpen={props.setOpenForm}
      title={
        props?.updateOrEdit == "update" ? t("UNITS.update_plate_number") : t("UNITS.edit_plate_number")
      }
      isFullScreen={false}
      content={
        <RenderContent
          object={unit}
          deleteImage={deleteImage}
          setObject={(value) => {
            console.log(value);

            setUnit(value)
          }}
          updateOrEdit={props?.updateOrEdit}
          open={props.openForm}
          setOpen={props.setOpenForm}
          isFullScreen={false}

        />
      }
      footer={
        <RenderFooter
          open={props.openForm}
          setOpen={props.setOpenForm}
          submit={submit}
          clearForm={clearForm}
        />
      }
    />
  );
}
